import { Component, AfterViewInit, Inject, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { UserService } from '../../shared/services/user.service';
import { TaskService } from '../../shared/services/task.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reallocate-task',
  templateUrl: './reallocate-task.component.html',
  styleUrls: ['./reallocate-task.component.scss']
})
export class ReallocateTaskModalComponent implements AfterViewInit {

   @Input() taskType: string = "Paralegal";
   @Input() selection: any[] =[];

  paralegalUsers: any[] = [];
  adminUsers: any[] = [];

  paralegalSearchInput = new UntypedFormControl();
  adminSearchInput = new UntypedFormControl();
  invalidSelection: boolean = true;
  saving: boolean = false;
  isLoading: boolean = false;
  
  selectedAdminUserName: string = '';
  selectedParalegalUserName: string = '';

  filteredAdminUsersList: any[] = [];
  filteredParalegalUsersList: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    userService: UserService,
    private taskService: TaskService) {
      
    userService.paralegals().subscribe(results => {

      for (const user of results) {
          this.paralegalUsers.push({ name: user.firstName + ' ' + user.lastName, id: user.id })
      }
      this.filteredParalegalUsersList = [...this.paralegalUsers];
    });

    userService.admins().subscribe(results => {

      for (const user of results) {
          this.adminUsers.push({ name: user.firstName + ' ' + user.lastName, id: user.id })
      }
      this.filteredAdminUsersList = [...this.adminUsers];
    });

  }

  ngAfterViewInit(): void {
  }

  paralegalSelectionUpdated(){

    this.invalidSelection = true;

    if(this.paralegalSearchInput.value != null && this.paralegalSearchInput.value != "" )
      this.invalidSelection = false;

  }

  adminSelectionUpdated(){

    this.invalidSelection = true;

    if(this.adminSearchInput.value != null && this.adminSearchInput.value != "")
      this.invalidSelection = false;

  }

  reallocateParalegalTasks(){

    this.saving = true;

    this.taskService.reallocateTasks(this.paralegalSearchInput.value.id, this.selection.map((x : any) => x.taskId)).subscribe((response : any) => {

      this.activeModal.close(true);
      this.taskService.refreshTasks.next();

      }, error => {
      });

  }

  reallocateAdminTasks(){

    this.saving = true;

    this.taskService.reallocateTasks(this.adminSearchInput.value.id, this.selection.map((x : any) => x.taskId)).subscribe((response : any) => {

      this.activeModal.close(true);
      this.taskService.refreshTasks.next();

      }, error => {
      });

  }

  cancel(){
    this.activeModal.dismiss();
  }

  filterParalegalUsers(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.filteredParalegalUsersList = this.paralegalUsers.filter(user => 
        user.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.filteredParalegalUsersList = [...this.paralegalUsers];
    }
  }

  filterAdminUsers(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.filteredAdminUsersList = this.adminUsers.filter(user => 
        user.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.filteredAdminUsersList = [...this.adminUsers];
    }
  }

 
  selectParalegal(user: any) {
    this.paralegalSearchInput.setValue(user);
    this.selectedParalegalUserName = user.name;
    this.paralegalSelectionUpdated();
  }

  selectAdmin(user: any) {
    this.adminSearchInput.setValue(user);
    this.selectedAdminUserName = user.name;
    this.adminSelectionUpdated();
  }

}
